<template>
	<div>
		<b-tabs v-model="activeTab">
			<b-tab title="Все отмеченные"></b-tab>
			<b-tab title="Мероприятия">
				<payment-table
					type="event"
					:dateStart="getDateStart()"
				></payment-table>
			</b-tab>
			<b-tab title="Услуги"></b-tab>
			<b-tab title="Продукты"></b-tab>
			<b-tab title="Онлайн"></b-tab>
			<b-tab title="Офлайн"></b-tab>
			<b-tab title="Свалка"></b-tab>
			<b-tab title="Отчётность"></b-tab>
		</b-tabs>
	</div>
</template>
<script>
import PaymentTable from '@/components/payment/payment-table'
export default {
	components: {
		'payment-table': PaymentTable
	},
	data () {
		return {
			activeTab: 1,
			type: '',
			tabs: {
				0: 'all',
				1: 'event',
				2: 'service',
				3: 'product',
				4: 'online',
				5: 'offline',
				6: 'trash',
				7: 'statistic'
			}
		}
	},
	mounted () {
		if (typeof this.$route.query.date_start !== 'undefined') {
			this.dateStart = this.$route.query.date_start
			// console.log(this.dateStart)
		}
		this.type = this.$route.params.type
	},
	methods: {
		getDateStart () {
			return typeof this.$route.query.date_start !== 'undefined' ? this.$route.query.date_start : ''
		}
	},
	watch: {
		activeTab: function (value) {
			this.$router.push({path: '/payments/list/' + this.tabs[value], query: {'date_start': this.$route.query.date_start}})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/payment/list/event.vue